import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaUserGraduate, FaTrash, FaEdit, FaSearch, FaMale, FaFemale, FaExclamationCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../services/api";

/* CONTAINER */
const Container = styled.div`
  padding: 2rem;
  background: #f4f6fb;
  min-height: 100vh;
  font-family: "Segoe UI", sans-serif;
`;

/* CARD */
const Card = styled.div`
  
  background: white;
  border-radius: 25px;
  padding: 25px;
  box-shadow: 0 15px 40px rgba(0,0,0,0.08);
`;

/* TOTAL DE HOMENS E MULHERES */
const GenderCard = styled.div`
  background: #fff;
  border-radius: 50px;
  padding: 12px 22px;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.12);
  color: #00226a;
`;

/* HEADER FLEX */
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  flex-wrap: wrap;
  gap: 15px;
`;

/* TOTAL ALUNOS */
const TotalCard = styled.div`
  background: linear-gradient(135deg,#c70303,#420000);
  color: white;
  border-radius: 50px;
  padding: 15px 30px;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
`;

/* SEARCH */
const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: #eef2ff;
  border-radius: 50px;
  padding: 10px 18px;
  gap: 10px;
  min-width: 280px;

  input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 15px;
    width: 100%;
  }

  svg {
    color: #3b82f6;
  }
`;

/* TABELA WRAPPER SCROLL */
const TableWrapper = styled.div`
  overflow-x: auto;
`;

/* TABELA FLEX */
const Table = styled.div`
  min-width: 900px;
`;

/* LINHA */
const Row = styled.div`
  display: flex;
  padding: 14px;
  border-bottom: 1px solid #eee;
  align-items: center;
  &:hover { background: #f8fafc; }
`;

/* HEADER ROW */
const HeaderRow = styled(Row)`
  background: #3b82f6;
  color: white;
  font-weight: bold;
  border-radius: 12px 12px 0 0;
`;

/* CELULA */
const Cell = styled.div`
  flex: 1;
`;

/* AÇÕES */
const Actions = styled.div`
  display: flex;
  gap: 8px;
`;

/* BOTÕES */
const Button = styled.button`
  border: none;
  padding: 7px 12px;
  border-radius: 8px;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EditBtn = styled(Button)` background: #3b82f6; `;
const DeleteBtn = styled(Button)` background: #c70303; `;

/* OVERLAY */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  animation: fadeIn 0.25s ease;

  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
`;

/* MODAL */
const Modal = styled.div`
  background: #fff;
  padding: 35px 30px;
  border-radius: 25px;
  width: 460px;
  max-width: 90%;
  box-shadow: 0 25px 50px rgba(0,0,0,0.2);
  position: relative;
  animation: slideUp 0.3s ease;

  h3 {
    margin-bottom: 25px;
    font-size: 22px;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #111827;
  }

  @keyframes slideUp { from { transform: translateY(50px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
`;

/* BOTÃO DE FECHAR */
const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 35px;
  height: 35px;
  background: #f3f4f6;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  transition: all 0.3s ease;
  &:hover { background: #ef4444; color: white; }
  &:focus { outline: none; }
`;

/* FORM */
const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;

  input, select {
    padding: 14px 18px;
    border-radius: 12px;
    border: 1px solid #ddd;
    font-size: 15px;
    transition: all 0.2s ease;
    &:focus { border-color: #3b82f6; box-shadow: 0 0 0 4px rgba(59,130,246,0.2); }
  }

  button {
    background: #3b82f6;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 12px;
    padding: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    font-size: 16px;
    box-shadow: 0 8px 20px rgba(59,130,246,0.4);
    transition: all 0.3s ease;
    svg { font-size: 18px; transition: transform 0.3s ease; }
    &:hover { background: #2563eb; transform: translateY(-2px); }
    &:hover svg { transform: rotate(-15deg); }
  }
`;

/* DIV NENHUM ALUNO */
const NoData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px;
  color: #9ca3af;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  gap: 15px;

  svg {
    font-size: 50px;
  }
`;

export default function AlunosPage(){

  const [alunos,setAlunos] = useState([]);
  const [busca,setBusca] = useState("");
  const [editando,setEditando] = useState(null);

  const totalHomens = alunos.filter(a => a.sexo === "M").length;
  const totalMulheres = alunos.filter(a => a.sexo === "F").length;

  const [form,setForm] = useState({ nome:"", sexo:"M", telefone:""});

  const loadAlunos = async ()=>{
    try{ const res = await api.get("/alunos"); setAlunos(res.data); }
    catch{ toast.error("Erro ao carregar"); }
  };

  useEffect(()=>{ loadAlunos(); },[]);

  const formatarData = d => d ? new Date(d).toLocaleDateString("pt-MZ") : "";

  const alunosFiltrados = alunos.filter(a =>
    a.nome?.toLowerCase().includes(busca.toLowerCase()) ||
    a.telefone?.toLowerCase().includes(busca.toLowerCase()) ||
    a.sexo?.toLowerCase().includes(busca.toLowerCase())
  );

  const handleEdit = aluno=>{
    setEditando(aluno.id);
    setForm({ ...aluno });
  };

  const handleDelete = async id=>{
    await api.delete(`/alunos/${id}`);
    toast.error("Aluno eliminado!");
    loadAlunos();
  };

  const handleSubmit = async e=>{
    e.preventDefault();
    await api.put(`/alunos/${editando}`,form);
    toast.success("Atualizado!");
    setEditando(null);
    loadAlunos();
  };

  return(
    <Container>
      <Card>
        <Header>
          <TotalCard>Total: {alunos.length} alunos</TotalCard>
          <GenderCard><FaMale /> {totalHomens} Homens</GenderCard>
          <GenderCard><FaFemale/> {totalMulheres} Mulheres</GenderCard>
          <SearchBox>
            <FaSearch/>
            <input placeholder="Pesquisar aluno..." value={busca} onChange={e=>setBusca(e.target.value)} />
          </SearchBox>
        </Header>

        <TableWrapper>
          {alunosFiltrados.length === 0 ? (
            <NoData>
              <FaExclamationCircle />
              Nenhum aluno encontrado
            </NoData>
          ) : (
            <Table>
              <HeaderRow>
                <Cell>ID</Cell>
                <Cell>Nome</Cell>
                <Cell>Sexo</Cell>
                <Cell>Telefone</Cell>
                <Cell>Ações</Cell>
              </HeaderRow>

              {alunosFiltrados.map(a=>(
                <Row key={a.id}>
                  <Cell>{a.id}</Cell>
                  <Cell>{a.nome}</Cell>
                  <Cell>{a.sexo}</Cell>
                  <Cell>{a.telefone}</Cell>
                  <Cell>
                    <Actions>
                      <EditBtn onClick={()=>handleEdit(a)}><FaEdit/></EditBtn>
                      <DeleteBtn onClick={()=>handleDelete(a.id)}><FaTrash/></DeleteBtn>
                    </Actions>
                  </Cell>
                </Row>
              ))}
            </Table>
          )}
        </TableWrapper>
      </Card>

      {editando && (
        <Overlay>
          <Modal>
            <CloseButton onClick={() => setEditando(false)}>×</CloseButton>
            <h3><FaUserGraduate /> Editar Aluno</h3>
            <Form onSubmit={handleSubmit}>
              <input name="nome" value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})} />
              <select name="sexo" value={form.sexo} onChange={e=>setForm({...form,sexo:e.target.value})}>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
              </select>
              <input value={form.telefone} onChange={e=>setForm({...form,telefone:e.target.value})} />
              <button type="submit"><FaEdit /> Atualizar</button>
            </Form>
          </Modal>
        </Overlay>
      )}
    </Container>
  );
}
